import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyRadioInputWithIcon } from '../../../../../components/common/survey/inputs/SurveyRadioInputWithIcon';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessJobPage = () => {
  const navigate = useNavigate();
  const [job, setJob] = useState<'농업 종사자' | '농기계 사업 종사자' | '일반 회원'>();

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const nextPagePathName = useMemo<undefined | 'crop-type' | 'business-name' | 'job-detail'>(() => {
    if (job === '농업 종사자') {
      return 'crop-type';
    }

    if (job === '농기계 사업 종사자') {
      return 'business-name';
    }

    if (job === '일반 회원') {
      return 'job-detail';
    }

    return undefined;
  }, [job]);

  return (
    <JoinProcessPageWrapper
      headerTitle={'어떤 분이신지 알려주세요'}
      description={'구분에 따라 절차가 달라집니다.\n회원님이 어떤 분인지 알 수 있도록 알려주세요.'}
      canConfirm={job !== undefined}
      confirmHandler={() => {
        dispatch(userJoinActions.changeJob(job!));
        navigate(`/join-process/${nextPagePathName}`, { replace: true });
      }}
    >
      <SurveyForm>
        <SurveyRadioInputWithIcon
          iconName={'JobFarmer'}
          isActive={job === '농업 종사자'}
          title={'농업 종사자'}
          label={'각종 농·축산업'}
          onClick={() => setJob('농업 종사자')}
        />
        <SurveyRadioInputWithIcon
          iconName={'JobCompany'}
          isActive={job === '농기계 사업 종사자'}
          title={'농기계 사업 종사자'}
          label={'대리점, 수리점 등'}
          onClick={() => setJob('농기계 사업 종사자')}
        />
        <SurveyRadioInputWithIcon
          iconName={'JobCommon'}
          isActive={job === '일반 회원'}
          title={'일반 회원'}
          label={'농업 및 농기계 사업 종사자 외'}
          onClick={() => setJob('일반 회원')}
        />
      </SurveyForm>
    </JoinProcessPageWrapper>
  );
};
